import script from "./PayMent.vue?vue&type=script&lang=ts&setup=true"
export * from "./PayMent.vue?vue&type=script&lang=ts&setup=true"

import "./PayMent.vue?vue&type=style&index=0&id=04c45b68&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04c45b68"]])

export default __exports__